//===================services carousel data =================
export const servicesCarouselData = [
  {
    id: 1,
    image: '/assets/images/portfolio/privateBirthdayParty/2.png',
    event: 'Tech Event',
    location: 'Lahore',
    date: '29-08-2022',
  },
  {
    id: 2,
    image: '/assets/images/portfolio/privateBirthdayParty/1.png',
    event: 'Tech Event',
    location: 'Lahore',
    date: '29-08-2022',
  },
  {
    id: 3,
    image: '/assets/images/home/carousel/carouselImg3.png',
    event: 'Tech Event',
    location: 'Lahore',
    date: '29-08-2022',
  },
  {
    id: 4,
    image: '/assets/images/portfolio/privateBirthdayParty/4.png',
    event: 'Tech Event',
    location: 'Lahore',
    date: '29-08-2022',
  },
  {
    id: 5,
    image: '/assets/images/portfolio/privateBirthdayParty/2.png',
    event: 'Tech Event',
    location: 'Lahore',
    date: '29-08-2022',
  },
  {
    id: 6,
    image: '/assets/images/portfolio/privateBirthdayParty/1.png',
    event: 'Tech Event',
    location: 'Lahore',
    date: '29-08-2022',
  },
  {
    id: 7,
    image: '/assets/images/home/carousel/carouselImg3.png',
    event: 'Tech Event',
    location: 'Lahore',
    date: '29-08-2022',
  },
];

//===================client review carousel data =================
export const clientReviewData = [
  {
    id: 1,
    image: '/assets/images/home/carousel/clientImg1.png',
    name: 'Matthew Paul',
    details:
      'Perfect, very good job! Thank you for the amazing design and work. Really impressed with the high quality and quick turnaround time. Highly recommend.',
  },
  {
    id: 2,
    image: '/assets/images/home/carousel/clientImg1.png',
    name: 'Matthew Paul',
    details:
      'Perfect, very good job! Thank you for the amazing design and work. Really impressed with the high quality and quick turnaround time. Highly recommend.',
  },
  {
    id: 3,
    image: '/assets/images/home/carousel/clientImg1.png',
    name: 'Matthew Paul',
    details:
      'Perfect, very good job! Thank you for the amazing design and work. Really impressed with the high quality and quick turnaround time. Highly recommend.',
  },
  {
    id: 4,
    image: '/assets/images/home/carousel/clientImg1.png',
    name: 'Matthew Paul',
    details:
      'Perfect, very good job! Thank you for the amazing design and work. Really impressed with the high quality and quick turnaround time. Highly recommend.',
  },
  {
    id: 5,
    image: '/assets/images/home/carousel/clientImg1.png',
    name: 'Matthew Paul',
    details:
      'Perfect, very good job! Thank you for the amazing design and work. Really impressed with the high quality and quick turnaround time. Highly recommend.',
  },
  {
    id: 6,
    image: '/assets/images/home/carousel/clientImg1.png',
    name: 'Matthew Paul',
    details:
      'Perfect, very good job! Thank you for the amazing design and work. Really impressed with the high quality and quick turnaround time. Highly recommend.',
  },
];
